import { render, staticRenderFns } from "./comp-email-process-mapper-form.vue?vue&type=template&id=0820310b&scoped=true&"
import script from "./js/comp-email-process-mapper-form.js?vue&type=script&lang=js&"
export * from "./js/comp-email-process-mapper-form.js?vue&type=script&lang=js&"
import style0 from "./comp-email-process-mapper-form.vue?vue&type=style&index=0&id=0820310b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0820310b",
  null
  
)

export default component.exports